import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { Route, Routes } from 'react-router-dom';

import NotFound from '@/components/NotFound/NotFound';
import { NotificationToaster } from '@/components/Notification/NotificationToaster';
import RequireVersementSession from '@/components/RequireVersementSession/RequireVersementSession';
import RequireWizardState from '@/components/RequireWizardState/RequireWizardState';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { ROUTE } from '@/constants/route';
import ArbitrageCertificates from '@/pages/ArbitrageCertificates/ArbitrageCertificates';
import ArbitrageSignature from '@/pages/ArbitrageSignature/ArbitrageSignature';
import ArbitrageSignatureResult from '@/pages/ArbitrageSignatureResult/ArbitrageSignatureResult';
import ArbitrageSummary from '@/pages/ArbitrageSummary/ArbitrageSummary';
import { AssuranceVieDetails } from '@/pages/AssuranceVieDetails';
import { AutresAcces } from '@/pages/AutresAcces/AutresAcces';
import { Contracts } from '@/pages/Contracts/Contracts';
import { Dashboard } from '@/pages/Dashboard';
import { DefiscDetails } from '@/pages/DefiscDetails';
import { FaireVersement } from '@/pages/FaireVersement';
import { FaireVersementCancel } from '@/pages/faireVersementCancel';
import { FaireVersementError } from '@/pages/faireVersementError';
import { FaireVersementFail } from '@/pages/faireVersementFail';
import { FaireVersementJustificatifs } from '@/pages/faireVersementJustificatifs';
import { FaireVersementSignature } from '@/pages/faireVersementSignature';
import { FaireVersementSucces } from '@/pages/faireVersementSucces';
import { FaireVersementValidation } from '@/pages/faireVersementValidation';
import { HelpPage } from '@/pages/HelpPage/HelpPage';
import { ImmoDetails } from '@/pages/ImmoDetails';
import { Informations } from '@/pages/informations';
import { Investir } from '@/pages/Investir';
import { LivretDetails } from '@/pages/LivretDetails';
import { Operations } from '@/pages/Operations/Operations';
import { RappelConseiller } from '@/pages/RappelConseiller';
import { RetraiteDetails } from '@/pages/RetraiteDetails';
import { SelectContract } from '@/pages/SelectContract/SelectContract';
import { SelectOperation } from '@/pages/SelectOperation/SelectOperation';
import { Sponsorship } from '@/pages/Sponsorship/Sponsorship';
import { ValidationRappelConseiller } from '@/pages/ValidationRappelConseiller';
import VueConseiller from '@/pages/vueConseiller/VueConseiller';

import styles from './styles.module.css';

export const MainLayout: React.FC = () => {
  return (
    <div id={styles.content}>
      <NotificationToaster />
      <MtxGrid>
        <Routes>
          <Route path={ROUTE.DASHBOARD} Component={Dashboard} />
          <Route path={ROUTE.CONTRATS} Component={Contracts} />
          <Route path={ROUTE.OPERATIONS} Component={Operations} />
          <Route path={ROUTE.INFORMATIONS} Component={Informations} />
          <Route path={ROUTE.INVESTIR} Component={Investir} />
          <Route path={ROUTE.HELP} Component={HelpPage} />

          <Route path={ROUTE.PARRAINAGE} Component={Sponsorship} />
          <Route path={ROUTE.AUTRESACCES} Component={AutresAcces} />
          <Route path={ROUTE.SELECTCONTRACT} Component={SelectContract} />
          <Route path={ROUTE.SELECTOPERATION} Component={SelectOperation} />
          <Route path={ROUTE.RAPPELCONSEILLER} Component={RappelConseiller} />
          <Route path={ROUTE.VALIDATIONRAPPELCONSEILLER} Component={ValidationRappelConseiller} />

          <Route path={ROUTE.ASSURANCEVIE} Component={AssuranceVieDetails} />
          <Route path={ROUTE.DEFISCALISATION} Component={DefiscDetails} />
          <Route path={ROUTE.IMMOBILIER} Component={ImmoDetails} />
          <Route path={ROUTE.RETRAITE} Component={RetraiteDetails} />
          <Route path={ROUTE.LIVRET} Component={LivretDetails} />

          <Route element={<RequireWizardState />}>
            <Route path={ROUTE.DEPOSIT} Component={FaireVersement} />
            <Route path={ROUTE.FAIREVERSEMENTJUSTIFICATIFS} Component={FaireVersementJustificatifs} />
            <Route path={ROUTE.FAIREVERSEMENTSIGNATURE} Component={FaireVersementSignature} />
            <Route path={ROUTE.FAIREVERSEMENTVALIDATION} Component={FaireVersementValidation} />
          </Route>
          <Route element={<RequireVersementSession />}>
            <Route path={ROUTE.FAIREVERSEMENTSUCCES} Component={FaireVersementSucces} />
            <Route path={ROUTE.FAIREVERSEMENTCANCEL} Component={FaireVersementCancel} />
            <Route path={ROUTE.FAIREVERSEMENTFAIL} Component={FaireVersementFail} />
            <Route path={ROUTE.FAIREVERSEMENTERROR} Component={FaireVersementError} />
          </Route>

          {FEATURE_FLAGS.ARBITRAGE && (
            <>
              <Route path={ROUTE.ARBITRAGESUMMARY} Component={ArbitrageSummary} />
              <Route path={ROUTE.ARBITRAGEJUSTIFICATIFS} Component={ArbitrageCertificates} />
              <Route path={ROUTE.ARBITRAGESIGNATURE} Component={ArbitrageSignature} />
              <Route path={ROUTE.ARBITRAGESIGNATURESUCCESS} Component={ArbitrageSignatureResult} />
              <Route path={ROUTE.ARBITRAGESIGNATUREERROR} Component={ArbitrageSignatureResult} />
              <Route path={ROUTE.ARBITRAGESIGNATUREREFUSAL} Component={ArbitrageSignatureResult} />
            </>
          )}

          <Route path={ROUTE.SSOCONSEILLER} Component={VueConseiller} />

          <Route path={ROUTE.NOTFOUND} Component={NotFound} />
        </Routes>
      </MtxGrid>
    </div>
  );
};
